import React from 'react';
import { CheckCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import moment from 'moment';

import style from './index.less';

const MessageEvent = ({ data, render = () => {} }) => {
  const { eventStatus, content, time, customEvent, isLastStream = false } = data;

  const switchIcon = status => {
    let icon;
    switch (status) {
      case 'info':
        icon = <InfoCircleFilled style={{ color: '#15C292' }} />;
        break;
      case 'error':
        icon = <InfoCircleFilled style={{ color: '#FF7474' }} />;
        break;
      case 'success':
        icon = <CheckCircleFilled style={{ color: '#1880ff' }} />;
        break;
      default:
        icon = <CheckCircleFilled style={{ color: '#1880ff' }} />;
    }
    return icon;
  };

  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={`${style['info-wrapper']} ${isLastStream ? style['last-stream'] : ''} ${style['msg-event-wrap']}`}>
      {customEvent ? (
        <ul className={style['msg-event']}>{content}</ul>
      ) : (
        <ul className={style['msg-event']}>
          <li className={style['event-icon']}>{switchIcon(eventStatus)}</li>
          <li className={style['event-content']}>
            <span style={{ paddingRight: 10 }}>{date}</span>
            <span>{content}</span>
          </li>
        </ul>
      )}
    </div>
  );
};

export default MessageEvent;
